import { Subject } from 'rxjs';

const subject = new Subject();

export const eventService = {
  sendEvent: (type, detail) => subject.next({ type, detail }),
  getEvent: () => subject.asObservable()
};
